module.exports = __webpack_public_path__ + "static/media/indentplanner.9a2c4f13.png";